export const az = {
  title: 'PRODES (Legal Amazon)',
  subtitle: 'illik, 6,25 ha, Legal Amazon, INPE',
  content: [
    {
      label: 'Funksiya',
      value:
        'Braziliya hökuməti tərəfindən dövlət siyasətinin qurulması üçün istifadə edilən Braziliya Qanuni Amazonu üçün meşələrin qırılmasının monitorinqi sistemi',
    },
    {
      label: 'Qətmə',
      value: '6,25 ha',
    },
    {
      label: 'Coğrafi əhatə',
      value: 'Braziliya qanuni Amazon',
    },
    {
      label: 'Mənbə',
      value: 'INPE',
    },
    {
      label: 'Tezlik',
      value: 'Hər il',
    },
    {
      label: 'Məzmun tarixi',
      value: '2008-2021',
    },
    {
      label: 'Xəbərdarlıqlar',
      value:
        'PRODES yalnız 6,25 hektar və ya daha böyük meşə sahələrini müəyyən edir, buna görə də meşənin deqradasiyası və ya yanğından və ya seçmə ağac kəsilməsindən daha kiçik təmizliklər aşkar edilmir. Əhatə zonalarının əraziləri üzərində tez-tez bulud örtüyü bildirilən meşələrin qırılması ilini dəyişə bilər. Məlumat verilmiş il meşələrin qırılmasının analitiklər tərəfindən müəyyən edildiyi ilk ildir, lakin əvvəlki illərdə landşaft buludlarla örtülmüşdürsə, bu, mütləq meşələrin qırılma ilinə uyğun gəlmir.',
    },
    {
      label: 'Lisenziya',
      value: 'Creative Commons BY SA 3.0',
    },
  ],
  overview: {
    label: 'Ümumi baxış',
    value:
      'PRODES layihəsi Braziliya Amazon və Cerrado biomlarında açıq kəsilmiş meşələrin qırılmasına nəzarət edir və 1988-ci ildən bəri region üçün illik meşə qırılma dərəcələri istehsal edir. Braziliya hökuməti bu rəqəmlərdən Amazon biomunda kreditə çıxış imkanlarının müəyyən edilməsi, meşələrin qırılmasının azaldılması hədəflərinin müəyyən edilməsi və meşələrin qırılmasının azaldılması üçün vəsait tələb edilməsi daxil olmaqla, dövlət siyasətini qurmaq üçün istifadə edir. PRODES tarixən Landsat 5 şəkillərindən istifadə edirdi, lakin indi Landsat 7 və 8, CBERS-2, CBERS-2B, Resourcesat-1 və UK2-DMC-dən olan görüntüləri də özündə birləşdirir. PRODES Milli Kosmik Tədqiqatlar İnstitutu (INPE) tərəfindən Ətraf Mühit Nazirliyi (MMA) və Braziliya Ətraf Mühit və Bərpa Olunan Təbii Sərvətlər İnstitutu (IBAMA) ilə əməkdaşlıqda idarə olunur. 2002-ci ildən bəri bütün PRODES məlumatları onlayn olaraq açıqdır. Braziliya Amazonunu və Cerradonu əhatə edən 220 Landsat ayaq izinin hər biri üçün daxil edilmiş şəkillər bulud örtüyünün olmaması və çəkilmə tarixi əsasında seçilir. PRODES sistemi illik meşələrin qırılmasını hesablamaq üçün avqustun 1-dən başlayaraq mövsümi ildən istifadə edir, buna görə də şəkillər mümkün qədər bu tarixə yaxın seçilir (ümumiyyətlə iyul, avqust və sentyabr ayları). 2003-2005-ci illərdə analitiklər SPRING proqramından istifadə edərək bitki örtüyünün, torpağın və kölgənin komponentlərini müəyyən etmək üçün təsvirin transformasiyasından istifadə ediblər. Bu komponentlər seqmentlərə bölünərək meşə, qeyri-meşə, hədəf ildə meşələrin qırılması, əvvəlki meşələrin qırılması, buludlar və su siniflərinə bölünüb, sonra ekspertlər tərəfindən əl ilə düzəldilir. 2005-ci ildən başlayaraq açıq mənbəli TerraAmazon platformasından istifadə edən yeni metodologiya tətbiq olundu. Platforma PRODES təhlilinin daha vahid olmasına imkan verir və müxtəlif peyklərdən alınan görüntüləri özündə birləşdirə bilir. Əvvəlki kimi, şəkillər mümkün qədər buludsuz olmaq üçün seçilir. Şəkillər daha sonra əvvəlki ilin təhlilindən istifadə edərək qeyri-meşə, əvvəlki meşələrin qırılması və suyu istisna etmək üçün maskalanır. Analitiklər daha sonra əvvəlki ilin bütöv meşəsindəki meşəsiz çoxbucaqlıları təsvir edirlər. Bu məlumat dəsti Nrazilian Legal Amazon-da 2008-2020-ci illərdə illik meşələrin qırılmasını göstərir.',
  },
  citation: {
    label: 'Sitat',
    value:
      "Milli Kosmik Tədqiqatlar İnstitutu (INPE). 'meşələrin qırılmasına səbəb olur.' Qlobal Forest Watch vasitəsilə [tarix] tarixində əldə edilib. www.globalforestwatch.org",
  },
};
